<template>
  <q-input
    v-if="measurementMetricGroup === 'frequency'"
    v-model.number="value"
    type="number"
    :suffix="measurementMetric?.suffix"
    :hint="hint"
    :min="0"
    input-class="text-right"
  />
  <q-input
    v-else-if="measurementMetricGroup === 'duration'"
    :model-value="formatDuration(value)"
    mask="#:##:##"
    :hint="hint
      ? `${hint} ${$t('programs.workflows.workflowDetails.inputDurationHelper')}`
      : $t('programs.workflows.workflowDetails.inputDurationHelper')"
    hide-hint
    fill-mask="0"
    input-class="text-right"
    @update:model-value="onInputDuration"
  />
  <q-input
    v-else-if="measurementMetricGroup === 'rate'"
    v-model.number="value"
    type="number"
    :suffix="measurementMetric?.suffix"
    :min="0"
    :hint="hint"
    input-class="text-right"
  />
  <q-input
    v-else-if="measurementMetricGroup === 'percentCorrect'"
    v-model.number="value"
    type="number"
    :suffix="measurementMetric?.suffix"
    :min="0"
    :max="100"
    :hint="hint"
    input-class="text-right"
  />
  <q-input
    v-else
    v-model.number="value"
    :suffix="measurementMetric?.suffix"
    :hint="hint"
    input-class="text-right"
  />
</template>

<script>
import { measurementMetrics } from 'boot/globals';
import Toolbox from 'src/mixins/Toolbox';

export default {
  name: 'DataInput',
  mixins: [Toolbox],
  props: {
    modelValue: {
      type: [null, Number],
      required: true,
    },
    metric: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],

  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(val) {
        if (typeof val !== 'number') {
          this.$emit('update:modelValue', null);
        } else {
          this.$emit('update:modelValue', val);
        }
      },
    }, // value()
    measurementMetric() {
      return measurementMetrics
        .find((metric) => (metric.id === this.metric));
    }, // measurementMetric()
    measurementMetricGroup() {
      return this.measurementMetric?.measurementMetricGroup || null;
    }, // measurementMetricGroup()
    suffix() {
      return this.measurementMetric?.suffix || '';
    },
  },
  methods: {
    onInputDuration(value) {
      this.value = this.stringToDuration(value);
    }, // onInputDuration()
  },
};
</script>
